import React from "react";
import PropTypes from "prop-types";
import TrackedCatalogLink from './TrackedCatalogLink';

const LinkedHeader = props => {
	return (
		<h2
			className={props.className}
			title={props.title}
		>
			<TrackedCatalogLink
				featureType={props.featureType}
				uniqueId={props.uniqueId}
				catalogLink={props.catalogLink}
			>
				{props.children}
			</TrackedCatalogLink>
		</h2>
	);
};

LinkedHeader.propTypes = {
    className: PropTypes.string,
    featureType: PropTypes.object.isRequired,
	uniqueId: PropTypes.string.isRequired,
	catalogLink: PropTypes.object,
}

export default LinkedHeader;


// WEBPACK FOOTER //
// ./src/react/views/generic/LinkedHeader.jsx